import { useHistory, useRouteMatch } from "react-router-dom";
import { useModal } from "../../core";
import { useCallback, useEffect, useMemo } from "react";
import useQueryState from "./useQueryState";
import { LinkTo } from "../constants/linkTo";

const useSingleTagModal = () => {
  // const modal = useModal();
  // const [{ tagModalOpen }, setQueryParams] = useQueryState();
  const history = useHistory();

  const showModal = useCallback(() => {
    history.push(LinkTo.tags);
    // modal.show('tags', {
    //   // tags,
    //   mode: 'link',
    //   onClose: () => setQueryParams({ tagModalOpen: null }, { replace: true })
    // });
    // setQueryParams({ tagModalOpen: true }, { replace: true });

  }, [history])

  // useEffect(() => {
  //   if (tagModalOpen) {
  //     showModal()
  //   }
  // }, [tagModalOpen])

  return [showModal];
}

export default useSingleTagModal;import { useHistory, useRouteMatch } from "react-router-dom";
import { useModal } from "../../core";
import { useCallback, useEffect, useMemo } from "react";
import useQueryState from "./useQueryState";
import { LinkTo } from "../constants/linkTo";

const useSingleTagModal = () => {
  // const modal = useModal();
  // const [{ tagModalOpen }, setQueryParams] = useQueryState();
  const history = useHistory();

  const showModal = useCallback(() => {
    history.push(LinkTo.tags);
    // modal.show('tags', {
    //   // tags,
    //   mode: 'link',
    //   onClose: () => setQueryParams({ tagModalOpen: null }, { replace: true })
    // });
    // setQueryParams({ tagModalOpen: true }, { replace: true });

  }, [history])

  // useEffect(() => {
  //   if (tagModalOpen) {
  //     showModal()
  //   }
  // }, [tagModalOpen])

  return [showModal];
}

export default useSingleTagModal;